import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import LandingNavbar from "./navbar.component";
import React from "react";
import Footer from "./footer.component";
import "./style.css";

export default function TermsAndCondition() {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <LandingNavbar />
      </Container>
      <div className="purpose">
        <Container>
          <Row className="section mb-3">
            <Col className="hero-bc"></Col>
            <h1>Terms and Conditions</h1>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="mb-6">
          <Col sm={12} lg={{ span: 8, offset: 2 }}>
            <article className="mb-5">
              <h5>Effective Date: Apr 2025</h5>
              <p>
                Welcome to <strong>DynamicPixels</strong>! These Terms and
                Conditions ("Terms") govern your access to and use of our
                cloud-based services that provide tools and infrastructure for
                online game development ("Services"). By using our Services, you
                agree to these Terms.
              </p>
              <h3>1. Introduction</h3>
              <p>
                DynamicPixels is a Software-as-a-Service (SaaS) platform that
                offers backend services, real-time multiplayer features, data
                management, and development tools tailored for Unity, Unreal
                Engine, and other game development platforms.
              </p>
              <h3>2. Eligibility</h3>
              <ul>
                <li>
                  You must be at least 18 years old or the age of majority in
                  your jurisdiction.
                </li>
                <li>
                  You must be authorized to enter into a binding agreement if
                  using the service on behalf of a business or organization.
                </li>
              </ul>
              <h3>3. Account Registration</h3>
              <ul>
                <li>You must create an account to access the platform.</li>
                <li>
                  You are responsible for maintaining the confidentiality of
                  your credentials.
                </li>
                <li>
                  You agree to provide accurate and complete information during
                  registration.
                </li>
              </ul>
              <h3>4. Use of Services</h3>
              <p>
                You may use the Services solely for developing, testing, and
                deploying your own games or applications. You agree{" "}
                <strong>not</strong> to:
              </p>
              <ul>
                <li>Use the Services for any unlawful or harmful purpose.</li>
                <li>Reverse-engineer, copy, or resell the Services.</li>
                <li>
                  Interfere with or disrupt the Services or any associated
                  systems or networks.
                </li>
              </ul>
              <h3>5. Subscription and Billing</h3>
              <ul>
                <li>
                  Some features are available under paid plans (subscription).
                </li>
                <li>
                  Fees, billing cycles, and payment methods are described on our
                  Pricing Page.
                </li>
                <li>Subscriptions auto-renew unless canceled.</li>
                <li>You are responsible for all applicable taxes.</li>
              </ul>
              <h3>6. Data and Content</h3>
              <ul>
                <li>You retain ownership of your game data and content.</li>
                <li>
                  You grant us a limited license to host and process your
                  content only to provide the Services.
                </li>
                <li>
                  You are solely responsible for the legality and content of
                  your data.
                </li>
              </ul>
              <h3>7. Service Availability</h3>
              <p>
                We strive to provide reliable uptime, but we do not guarantee
                uninterrupted service. DynamicPixels may be temporarily
                unavailable due to maintenance or technical issues.
              </p>
              <h3>8. Termination</h3>
              <ul>
                <li>You may cancel your account at any time.</li>
                <li>
                  We reserve the right to suspend or terminate your account if
                  you violate these Terms.
                </li>
              </ul>
              <h3>9. Disclaimer of Warranties</h3>
              <p>
                The Services are provided "AS IS" without warranty of any kind.
                We disclaim all warranties including merchantability, fitness
                for a particular purpose, and non-infringement.
              </p>
              <h3>10. Limitation of Liability</h3>
              <p>
                To the maximum extent permitted by law, DynamicPixels shall not
                be liable for:
              </p>
              <ul>
                <li>Any indirect, incidental, or consequential damages.</li>
                <li>
                  Any loss of data, revenue, or business due to the use or
                  inability to use the Services.
                </li>
              </ul>
              <h3>11. Modifications to the Terms</h3>
              <p>
                We may revise these Terms from time to time. We will notify
                users of material changes. Continued use after changes implies
                acceptance.
              </p>
              <h3>12. Governing Law</h3>
              <p>
                These Terms are governed by the laws of Netherlands. Disputes
                shall be resolved in the courts of Netherlands.
              </p>
              <h3>13. Contact</h3>
              <p>
                If you have any questions about these Terms, please contact us
                at:
              </p>
              <h4>info@dynamicpixels.dev</h4>
            </article>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}
